import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportExternalAccountsReadyDialogComponent } from '@irb/irb-clients/import-external-accounts-ready-dialog/import-external-accounts-ready-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportExternalAccountsReadyGridLayoutService implements GridLayoutService<ImportExternalAccountsReadyDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Account Number',            
            field: 'accountNumber',
            maxWidth: 150,
            width: 150,
            sort:'asc'
        },
        {
            headerName: 'Status',
            field: 'status',
            maxWidth: 371
        },
        {
            headerName: 'Result',
            field: 'result',
            maxWidth: 170,
            width: 170
        }];
    }
}
